import TFGSubjectsTable from './TFGSubjectsTable';

export default TFGSubjectsTable;
